import { render, staticRenderFns } from "./GraficoPonteiro.vue?vue&type=template&id=323cf7f0"
import script from "./GraficoPonteiro.vue?vue&type=script&lang=js"
export * from "./GraficoPonteiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports